.filter-dropdown-button,
.filter-dropdown-button button {
  width: 100%;
  height: 40px;
}

.form-criteria-section {
  padding: 0 10px 10px;
  > * {
    margin-top: 10px;
  }
}

.checklist-row {
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 10px;

  .pill {
    margin-left: 10px;
  }
}
